<template>
  <div
    class="textarea-container"
    :class="{ disabled }">
    <slot />
    <slot name="bottom" />
  </div>
</template>

<script>
/**
 * @description textareaの下部に何か要素を置きたい場合に使うコンポーネント。textareaはpadding-bottomがうまく動かないので、divで囲い、そのdivにpaddingを効かせる必要がある。
 */
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.textarea-container {
  background-color: $white;
  border-radius: 4px;

  &.disabled {
    background-color: $grey15;
  }
}
</style>